<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4.063V17.77l-4.15 2.505c-.758.457-1.692-.222-1.492-1.083L7.46 14.47l-3.669-3.178c-.668-.58-.31-1.678.57-1.752l4.829-.41 1.89-4.458a.986.986 0 0 1 .92-.61Z"
    />
  </svg>
</template>
